import { CardContent } from '@mui/material';
import { CCardContentProps } from 'types/atoms';
import customTwMerge from 'utils/twMerge';

export default function CCardContent({
  title,
  description,
  className,
  titleClassName,
  descriptionClassName,
  isSentryMask,
}: CCardContentProps) {
  return (
    <CardContent
      className={customTwMerge('flex grow flex-col justify-center gap-1 p-0 last:p-0', className)}
    >
      <h5 data-sentry-mask={isSentryMask} className={customTwMerge('text-label16 text-neutral-700', titleClassName)}>{title}</h5>

      {description && (
        <p data-sentry-mask={isSentryMask} className={customTwMerge('text-body14 text-neutral-500', descriptionClassName)}>
          {description}
        </p>
      )}
    </CardContent>
  );
}
